import type { SupabaseClient } from '@supabase/supabase-js'
import type { Database } from '../db/supabase.types.ts'
import { parseAsset } from './utils.ts'

export async function getAssetById(assetId: string, ctx: { supabase: SupabaseClient<Database> }) {
  const { data, error } = await ctx.supabase
    .from('assets')
    .select(
      `*,
      users_assets(
        id,
        relation_type,
        data,
        user_id
      ),
      address:asset_addresses(*),
      prices:asset_prices(*)
    `
    )
    .eq('id', assetId)
    .is('asset_prices.deleted_at', null)
    .order('created_at', { ascending: false, referencedTable: 'asset_prices' })
    .maybeSingle()

  if (error) {
    console.error(error)
    return null
  }

  if (!data) {
    return null
  }

  return parseAsset(data)
}
